import { RoleMap } from './useGetRole';
import { useProfile } from './useProfile';

export const useIsAdmin = (): boolean | undefined => {
  const { profile, loading } = useProfile();

  if (loading) return;

  if (!profile) return false;

  return profile.role.includes(RoleMap['executive-admin']) || profile.role.includes(RoleMap.admin);
};
